import React from 'react';
import { JoinButton } from './JoinButton';

interface AskQuestionButtonProps {
  onClick: () => void;
}

export function AskQuestionButton({ onClick }: AskQuestionButtonProps) {
  return <JoinButton />;
}